export default {"src":"/_next/static/media/robot-oops.25320c76.svg","height":90,"width":92,"blurWidth":0,"blurHeight":0};